
import { OriginalMaterialType } from '../../carrier/sample';
import { MaterialType } from '../../carrier/carrier-enum';

export class ScanableMaterial {
    materialBarcode: string;
    materialName: string;
    materialReceived: boolean;
    materialNotReceivable: boolean;
    orderItemId: string;
    materialType: MaterialType;
    primerType: string;
    originalMaterialType: OriginalMaterialType;
    public constructor(materialBarcode: string, materialName: string, materialReceived: boolean, materialNotReceivable: boolean, orderItemId: string, materialType: MaterialType, primerType: string, originalMaterialType: OriginalMaterialType) {
        this.materialBarcode = materialBarcode;
        this.materialName = materialName;
        this.materialReceived = materialReceived;
        this.materialNotReceivable = materialNotReceivable;
        this.orderItemId = orderItemId;
        this.materialType = materialType;
        this.primerType = primerType
        this.originalMaterialType = originalMaterialType;
    }
}